import { apiPharmaInstance } from 'utils/axios';

export const sendMarkTooltip = (clientId) => {
    return apiPharmaInstance.post(`api/users/${clientId}/mark-tooltip`);
};
